/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';
import type { InternalApiAlertType } from './InternalApiAlertType';
import {
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeFromJSONTyped,
    InternalApiAlertTypeToJSON,
    InternalApiAlertTypeToJSONTyped,
} from './InternalApiAlertType';

/**
 * 
 * @export
 * @interface InternalApiAlertNoteTemplate
 */
export interface InternalApiAlertNoteTemplate {
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertNoteTemplate
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAlertNoteTemplate
     */
    templateHandle: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertNoteTemplate
     */
    organisationId: number;
    /**
     * 
     * @type {InternalApiAlertType}
     * @memberof InternalApiAlertNoteTemplate
     */
    alertType: InternalApiAlertType;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAlertNoteTemplate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAlertNoteTemplate
     */
    content: string;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiAlertNoteTemplate
     */
    createdBy?: InternalApiUserBasicDetails;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiAlertNoteTemplate
     */
    updatedBy?: InternalApiUserBasicDetails;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiAlertNoteTemplate
     */
    createdTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiAlertNoteTemplate
     */
    updatedTime: Date;
}



/**
 * Check if a given object implements the InternalApiAlertNoteTemplate interface.
 */
export function instanceOfInternalApiAlertNoteTemplate(value: object): value is InternalApiAlertNoteTemplate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('templateHandle' in value) || value['templateHandle'] === undefined) return false;
    if (!('organisationId' in value) || value['organisationId'] === undefined) return false;
    if (!('alertType' in value) || value['alertType'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    if (!('updatedTime' in value) || value['updatedTime'] === undefined) return false;
    return true;
}

export function InternalApiAlertNoteTemplateFromJSON(json: any): InternalApiAlertNoteTemplate {
    return InternalApiAlertNoteTemplateFromJSONTyped(json, false);
}

export function InternalApiAlertNoteTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertNoteTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'templateHandle': json['templateHandle'],
        'organisationId': json['organisationId'],
        'alertType': InternalApiAlertTypeFromJSON(json['alertType']),
        'name': json['name'],
        'content': json['content'],
        'createdBy': json['createdBy'] == null ? undefined : InternalApiUserBasicDetailsFromJSON(json['createdBy']),
        'updatedBy': json['updatedBy'] == null ? undefined : InternalApiUserBasicDetailsFromJSON(json['updatedBy']),
        'createdTime': (new Date(json['createdTime'])),
        'updatedTime': (new Date(json['updatedTime'])),
    };
}

export function InternalApiAlertNoteTemplateToJSON(json: any): InternalApiAlertNoteTemplate {
    return InternalApiAlertNoteTemplateToJSONTyped(json, false);
}

export function InternalApiAlertNoteTemplateToJSONTyped(value?: InternalApiAlertNoteTemplate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'templateHandle': value['templateHandle'],
        'organisationId': value['organisationId'],
        'alertType': InternalApiAlertTypeToJSON(value['alertType']),
        'name': value['name'],
        'content': value['content'],
        'createdBy': InternalApiUserBasicDetailsToJSON(value['createdBy']),
        'updatedBy': InternalApiUserBasicDetailsToJSON(value['updatedBy']),
        'createdTime': value['createdTime'].toISOString(),
        'updatedTime': value['updatedTime'].toISOString(),
    };
}

